import { render, staticRenderFns } from "./BatchDetailsView.vue?vue&type=template&id=7db44e8f&scoped=true"
import script from "./BatchDetailsView.vue?vue&type=script&lang=js"
export * from "./BatchDetailsView.vue?vue&type=script&lang=js"
import style0 from "./BatchDetailsView.vue?vue&type=style&index=0&id=7db44e8f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7db44e8f",
  null
  
)

export default component.exports